export enum ComponentNames {
  Input = "BasisInput",
}
